module.exports = __webpack_public_path__ + "img/Electronic1.9fc89118.png";